//
//
//
//
//
//
//
//
//
//
//

import alOverallFooter from '../components/al-overallFooter.vue'
import MeasurementHeader from '../components/measurementHeader.vue'
import HeaderMeterage from '../components/layout/HeaderMeterage.vue'
import Courier from '~/components/Courier'

export default {
  middleware: 'appData',
  data() {
    return {}
  },

  components: {
    alOverallFooter,
    MeasurementHeader, HeaderMeterage,
    Courier
  },

  computed: {},

  mounted() {
    this.queryHis()
    this.$bus.$on('changeBar', this.changeBar)
  },

  methods: {
    changeBar(type) {
      if (type == 'lasa') {
        this.navigationType = 'lasa'
        localStorage.setItem('navigationType', 'lasa')
        this.headerType = 'HeaderLasa'
        this.footerType = 'FooterLasa'
        document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
      } else if (type == 'gaoxiao') {
        this.navigationType = 'gaoxiao'
        localStorage.setItem('navigationType', 'gaoxiao')
        this.headerType = 'HeaderCollege'
        this.footerType = 'FooterCollege'
        document.title = '全国高校区域技术转移转化中心（江苏）一体化平台'
      } else if (type == 'jiliang') {
        this.navigationType = 'jiliang'
        localStorage.setItem('navigationType', 'jiliang')
        this.headerType = 'HeaderMeterage'
        this.footerType = ''
        document.title = '现代先进测量体系服务平台'
      }
    },
    queryHis() {
      const strCookie = document.cookie
      const cookies = strCookie.split(' ')
      let touristId = ''
      cookies.map(str => {
        if (str.includes('NW_TOURIST_ID')) {
          const tempArr = str.split('=')
          touristId = tempArr[1]

          if (touristId.indexOf(';') > 0) {
            touristId = touristId.substring(0, touristId.length - 1)
          }
          localStorage.setItem('TOURIST_ID', touristId)
        }
      })

      this.navigationType = 'jiliang'
      localStorage.setItem('navigationType', 'jiliang')
      this.headerType = 'HeaderMeterage'
      this.footerType = ''
      document.title = '现代先进测量体系服务平台'
    },
  }
}
